module.exports = __webpack_public_path__ + "img/WechatIMG30251.e6d85e94.jpg";